import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/admin/app';
import ItemList from 'flarum/common/utils/ItemList';
import generateElementId from 'flarum/common/utils/generateElementId';
import FormModal from 'flarum/common/components/FormModal';
import Button from 'flarum/common/components/Button';
import dayjs from 'dayjs';
import dayjsUtc from 'dayjs/plugin/utc';
dayjs.extend(dayjsUtc);
export default class StatisticsWidgetDateSelectionModal extends FormModal {
  constructor() {
    super(...arguments);
    /* @ts-expect-error core typings don't allow us to set the type of the state attr :( */
    _defineProperty(this, "state", {
      inputs: {
        startDateVal: dayjs().format('YYYY-MM-DD'),
        endDateVal: dayjs().format('YYYY-MM-DD')
      },
      ids: {
        startDate: generateElementId(),
        endDate: generateElementId()
      }
    });
  }
  oninit(vnode) {
    super.oninit(vnode);
    if (this.attrs.value) {
      this.state.inputs = {
        startDateVal: dayjs.utc(this.attrs.value.start * 1000).format('YYYY-MM-DD'),
        endDateVal: dayjs.utc(this.attrs.value.end * 1000).format('YYYY-MM-DD')
      };
    }
  }
  className() {
    return 'StatisticsWidgetDateSelectionModal Modal--small';
  }
  title() {
    return app.translator.trans('flarum-statistics.admin.date_selection_modal.title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, this.items().toArray());
  }
  items() {
    const items = new ItemList();
    items.add('intro', m("p", null, app.translator.trans('flarum-statistics.admin.date_selection_modal.description')), 100);
    items.add('date_start', m("div", {
      className: "Form-group"
    }, m("label", {
      htmlFor: this.state.ids.startDate
    }, app.translator.trans('flarum-statistics.admin.date_selection_modal.start_date')), m("input", {
      type: "date",
      id: this.state.ids.startDate,
      value: this.state.inputs.startDateVal,
      onchange: this.updateState('startDateVal'),
      className: "FormControl"
    })), 90);
    items.add('date_end', m("div", {
      className: "Form-group"
    }, m("label", {
      htmlFor: this.state.ids.endDate
    }, app.translator.trans('flarum-statistics.admin.date_selection_modal.end_date')), m("input", {
      type: "date",
      id: this.state.ids.endDate,
      value: this.state.inputs.endDateVal,
      onchange: this.updateState('endDateVal'),
      className: "FormControl"
    })), 80);
    items.add('submit', m(Button, {
      className: "Button Button--primary",
      type: "submit"
    }, app.translator.trans('flarum-statistics.admin.date_selection_modal.submit_button')), 0);
    return items;
  }
  updateState(field) {
    return e => {
      this.state.inputs[field] = e.currentTarget.value;
    };
  }
  submitData() {
    // We force 'zulu' time (UTC)
    return {
      start: Math.floor(+dayjs.utc(this.state.inputs.startDateVal + 'Z') / 1000),
      // Ensures that the end date is the end of the day
      end: Math.floor(+dayjs.utc(this.state.inputs.endDateVal + 'Z').hour(23).minute(59).second(59).millisecond(999) / 1000)
    };
  }
  onsubmit(e) {
    e.preventDefault();
    const data = this.submitData();
    if (data.end < data.start) {
      this.alertAttrs = {
        type: 'error',
        controls: app.translator.trans('flarum-statistics.admin.date_selection_modal.errors.end_before_start')
      };
      return;
    }
    this.attrs.onModalSubmit(data);
    this.hide();
  }
}
flarum.reg.add('flarum-statistics', 'admin/components/StatisticsWidgetDateSelectionModal', StatisticsWidgetDateSelectionModal);